import React from 'react'
import { observer } from 'mobx-react'
import './styles.sass'

const ImageChallengeView = ({ challenge }) => (
  <div className="image-challenge">
    <div className="image-container">
      <img src={challenge.image.source} alt="Image" />
    </div>
    <input
      type="text"
      className="input"
      placeholder="Write your answer here"
      value={challenge.answer}
      onChange={e => challenge.setAnswer(e.target.value)}
    />
  </div>
)

export default observer(ImageChallengeView)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/ImageChallenge/View.jsx